"use client";

export default function DashboardSkeletonClient() {
  return (
    <div className="home-content space-y-6">
      {/* Top prominent runner */}
      <div className="relative">
        <div className="runner-wrap">
          <span className="runner" aria-hidden />
        </div>
      </div>
      <section className="mb-6">
        <div className="mb-2 h-6 w-56 rounded bg-gradient-to-r from-gray-100 dark:from-slate-800 via-blue-50 dark:via-blue-950 to-gray-100 dark:to-slate-800 shimmer" />
        <div className="relative rounded-lg border bg-white dark:bg-slate-900 p-4 shadow-sm overflow-hidden">
          <div className="indeterminate" aria-hidden />
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="h-24 rounded-md border bg-gradient-to-br from-gray-50 dark:from-slate-900 via-blue-50 dark:via-blue-950 to-gray-50 dark:to-slate-900 shimmer" />
            ))}
          </div>
        </div>
      </section>

      <section className="mb-6">
        <div className="mb-2 h-6 w-72 rounded bg-gradient-to-r from-gray-100 dark:from-slate-800 via-emerald-50 dark:via-emerald-950 to-gray-100 dark:to-slate-800 shimmer" />
        <div className="relative rounded-lg border bg-white dark:bg-slate-900 p-4 shadow-sm overflow-hidden">
          <div className="indeterminate" aria-hidden />
          <div className="h-80 w-full rounded-md bg-gradient-to-br from-gray-50 dark:from-slate-900 via-emerald-50 dark:via-emerald-950 to-gray-50 dark:to-slate-900 shimmer" />
        </div>
      </section>

      <section className="mb-6">
        <div className="mb-2 h-6 w-64 rounded bg-gradient-to-r from-gray-100 dark:from-slate-800 via-indigo-50 dark:via-indigo-950 to-gray-100 dark:to-slate-800 shimmer" />
        <div className="relative rounded-lg border bg-white dark:bg-slate-900 p-4 shadow-sm overflow-hidden">
          <div className="indeterminate" aria-hidden />
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
            <div className="h-80 rounded-md bg-gradient-to-br from-gray-50 dark:from-slate-900 via-indigo-50 dark:via-indigo-950 to-gray-50 dark:to-slate-900 shimmer lg:col-span-2" />
            <div className="space-y-4">
              <div className="h-40 rounded-md bg-gradient-to-br from-gray-50 dark:from-slate-900 via-pink-50 dark:via-pink-950 to-gray-50 dark:to-slate-900 shimmer" />
              <div className="h-40 rounded-md bg-gradient-to-br from-gray-50 dark:from-slate-900 via-yellow-50 dark:via-yellow-950 to-gray-50 dark:to-slate-900 shimmer" />
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .shimmer {
          position: relative;
          overflow: hidden;
        }
        .shimmer::after {
          content: '';
          position: absolute;
          inset: 0;
          transform: translateX(-100%);
          background-image: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.6) 45%, rgba(59,130,246,0.08) 50%, rgba(255,255,255,0.6) 55%, rgba(255,255,255,0) 100%);
          animation: shimmer 1.8s ease-in-out infinite;
        }
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        .indeterminate {
          position: absolute;
          left: 12px;
          right: 12px;
          top: 10px;
            height: 3px;
          border-radius: 9999px;
          background: linear-gradient(90deg, rgba(59,130,246,0.12), rgba(34,197,94,0.14), rgba(99,102,241,0.14));
          overflow: hidden;
          box-shadow: 0 0 6px rgba(59,130,246,0.12), 0 0 4px rgba(34,197,94,0.1);
        }
        .indeterminate::before {
          content: '';
          position: absolute;
          inset: 0;
          transform: translateX(-100%);
          background: linear-gradient(90deg, transparent, rgba(59,130,246,0.5), transparent);
          animation: indeterminate 1.6s ease-in-out infinite;
          box-shadow: 0 0 4px rgba(59,130,246,0.35);
        }
        @keyframes indeterminate {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }

        /* Top runner (more prominent) */
        .runner-wrap {
          position: sticky;
          top: 0;
          z-index: 20;
          height: 4px;
          width: 100%;
          border-radius: 9999px;
          background: linear-gradient(90deg, rgba(59,130,246,0.15), rgba(16,185,129,0.15), rgba(99,102,241,0.15));
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(59,130,246,0.08) inset;
        }
        .runner {
          position: absolute;
          inset: 0;
          transform: translateX(-100%);
          background: linear-gradient(90deg, transparent, rgba(59,130,246,0.45), rgba(16,185,129,0.45), rgba(99,102,241,0.45), transparent);
          animation: runner 1.8s ease-in-out infinite;
          filter: drop-shadow(0 0 3px rgba(59,130,246,0.4));
        }
        @keyframes runner {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}
